export const UNIVERSES = [
  {
    slug: 'weddings',
    n: '01',
    title: 'Weddings',
    desc: 'Des célébrations pensées dans leur intégralité, où chaque choix révèle votre histoire.',
    slot: 'univers-weddings',
    fallback: 'https://images.unsplash.com/photo-1751257547111-9641cb540f4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  },
  {
    slug: 'receptions-corporate',
    n: '02',
    title: 'Réceptions privées & Corporate',
    desc: 'Des expériences conçues pour recevoir, rassembler et marquer les esprits.',
    slot: 'univers-receptions',
    fallback: 'https://images.unsplash.com/photo-1740120424442-ccd013ec9581?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  },
  {
    slug: 'heritage',
    n: '03',
    title: 'JBMH Héritage',
    desc: 'Les traditions révélées avec élégance, dans le respect de chaque histoire.',
    slot: 'univers-heritage',
    fallback: 'https://images.unsplash.com/photo-1533939361134-4135bbb3658c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  },
];

export const MAISON_FALLBACK = 'https://images.pexels.com/photos/6913089/pexels-photo-6913089.jpeg?auto=compress&cs=tinysrgb&w=1400';
